import { Component, inject, Input, OnInit } from '@angular/core'
import { RouterLink } from '@angular/router'
import { ComponentBase } from '../../intefaces/interfaces'
import { map, Observable } from 'rxjs'
import { CustomContent } from '../../services/custom-content/custom-content'
import { AsyncPipe, UpperCasePipe } from '@angular/common'
import { BodyLarge } from '../typography/body-large/body-large'
import { HeadlineLarge } from '../typography/headline-large/headline-large'

@Component({
	selector: 'app-city-list',
	imports: [RouterLink, AsyncPipe, UpperCasePipe, BodyLarge, HeadlineLarge],
	templateUrl: './city-list.html',
	styleUrl: './city-list.css',
})
export class CityList implements OnInit {
	@Input() content!: ComponentBase

	list$!: Observable<any>

	private customContentService = inject(CustomContent)

	ngOnInit(): void {
		this.list$ = this.customContentService.getListOfStatesAndCities().pipe(
			map((data) => {
				const sortedCities = data.states.map((state: any) => {
					const sortedCitiesByState = state.cities?.sort((a: any, b: any) =>
						a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
					)
					return {
						...state,
						cities: sortedCitiesByState,
					}
				})

				const sortedStates = sortedCities?.sort((a: any, b: any) =>
					a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
				)

				return {
					states: sortedStates,
				}
			}),
		)
	}
}
